import type { RouteRecordRaw } from "vue-router";
import { mobileBackGuard } from "./guards";

const phoneRoutes: RouteRecordRaw[] = [
  {
    path: "/phone",
    name: "Phone",
    component: () => import("../../views/phoneHome.vue"),
    beforeEnter: mobileBackGuard,
    redirect: "/phone/qa",
    meta: {
      keepAlive: true, // 是否使用 keep-alive
    },
    children: [
      {
        path: "qa",
        name: "QA",
        component: () => import("../../views/QAPage/phoneQAPage.vue"),
        meta: {
          keepAlive: true,
          footer: true,
        },
      },
      {
        path: "case-record-list",
        name: "CaseRecordList",
        component: () => import("../../views/CaseRecordList/phoneCaseList.vue"),
        meta: {
          keepAlive: true,
        },
      },

      {
        path: "case-draft-list",
        name: "CaseDraftList",
        component: () => import("../../views/CaseDraftList/phoneCaseList.vue"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
];

export default phoneRoutes;
